(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Hero-Uro"] && !Shopify.designMode) return;
  try {
    
(function () {
  var iniciar = function (lienzo) {
    if (lienzo.dataset.uroListo) return;
    lienzo.dataset.uroListo = '1';

    var ctx = lienzo.getContext('2d');
    if (!ctx) return;

    var escena = lienzo.parentElement;
    var seccion = lienzo.closest('.uro-hero');
    var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interactivo = lienzo.dataset.interactivo === 'true';
    var velocidad = parseFloat(lienzo.dataset.velocidad) || 4;
    var movil = window.innerWidth < 749;

    var aRgb = function (color) {
      ctx.fillStyle = '#000000';
      ctx.fillStyle = color || '#000000';
      var v = ctx.fillStyle;
      if (v.charAt(0) === '#') {
        return [parseInt(v.substr(1, 2), 16), parseInt(v.substr(3, 2), 16), parseInt(v.substr(5, 2), 16)];
      }
      var m = v.match(/[\d.]+/g);
      return m ? [+m[0], +m[1], +m[2]] : [0, 0, 0];
    };

    var cola = aRgb(lienzo.dataset.colorCola);
    var cabeza = aRgb(lienzo.dataset.colorCabeza);

    var tablaPasos = { baja: 90, media: 130, alta: 180 };
    var pasosU = tablaPasos[lienzo.dataset.densidad] || 130;
    if (movil) pasosU = Math.round(pasosU * 0.7);
    var pasosV = 14;
    var largo = Math.PI * 2 * 0.9;

    var radioTubo = function (f) {
      var r = 0.03 + 0.1 * f;
      if (f > 0.9) {
        var h = (f - 0.9) / 0.1;
        r = r + 0.05 * Math.sin(h * Math.PI) - 0.07 * h * h;
      }
      return r;
    };

    var puntos = [];
    for (var i = 0; i < pasosU; i++) {
      var f = i / (pasosU - 1);
      var r = radioTubo(f);
      var color = [
        cola[0] + (cabeza[0] - cola[0]) * f,
        cola[1] + (cabeza[1] - cola[1]) * f,
        cola[2] + (cabeza[2] - cola[2]) * f
      ];
      for (var j = 0; j < pasosV; j++) {
        puntos.push({ f: f, u: f * largo, v: (j / pasosV) * Math.PI * 2, r: r, c: color, x: 0, y: 0, z: 0, s: 0, luz: 0 });
      }
    }

    var ancho = 0;
    var alto = 0;
    var objetivoX = 0;
    var objetivoY = 0;
    var actualX = 0;
    var actualY = 0;
    var visible = true;
    var corriendo = false;
    var inicio = null;

    var medir = function () {
      var caja = escena.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      ancho = caja.width;
      alto = caja.height;
      lienzo.width = Math.round(ancho * dpr);
      lienzo.height = Math.round(alto * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    var dibujar = function (t) {
      if (!ancho || !alto) return;
      ctx.clearRect(0, 0, ancho, alto);

      actualX += (objetivoX - actualX) * 0.06;
      actualY += (objetivoY - actualY) * 0.06;

      var escala = Math.min(ancho, alto) * 0.3;
      var giro = t * 0.00012 * velocidad;
      var flujo = t * 0.0006 * velocidad;
      var inclX = 0.55 + actualY * 0.35;
      var inclY = actualX * 0.45 + Math.sin(t * 0.0003) * 0.12;
      var cX = Math.cos(inclX);
      var sX = Math.sin(inclX);
      var cY = Math.cos(inclY);
      var sY = Math.sin(inclY);
      var tamano = ancho / 480;

      for (var k = 0; k < puntos.length; k++) {
        var p = puntos[k];
        var u = p.u + giro;
        var cu = Math.cos(u);
        var su = Math.sin(u);
        var v = p.v + p.u * 3 + flujo;
        var cv = Math.cos(v);
        var sv = Math.sin(v);
        var ondula = 0.06 * Math.sin(p.u * 4 - flujo * 2);

        var x = (1 + p.r * cv) * cu;
        var y = (1 + p.r * cv) * su;
        var z = p.r * sv + ondula;

        var y1 = y * cX - z * sX;
        var z1 = y * sX + z * cX;
        var x2 = x * cY + z1 * sY;
        var z2 = -x * sY + z1 * cY;

        var ny = cv * su;
        var nz = sv;
        var nz1 = ny * sX + nz * cX;
        var nz2 = -(cv * cu) * sY + nz1 * cY;

        var persp = 4 / (4 + z2);
        p.x = ancho / 2 + x2 * escala * persp;
        p.y = alto / 2 + y1 * escala * persp;
        p.z = z2;
        p.s = persp;
        p.luz = 0.5 - 0.5 * nz2;
      }

      puntos.sort(function (a, b) { return b.z - a.z; });

      for (var n = 0; n < puntos.length; n++) {
        var q = puntos[n];
        var brillo = 0.55 + 0.45 * q.luz;
        var reflejo = 0.35 * Math.pow(q.luz, 6);
        var rr = Math.round(q.c[0] * brillo + (255 - q.c[0]) * reflejo);
        var gg = Math.round(q.c[1] * brillo + (255 - q.c[1]) * reflejo);
        var bb = Math.round(q.c[2] * brillo + (255 - q.c[2]) * reflejo);
        var alfa = Math.max(0.3, Math.min(1, (1.3 - q.z) / 2.2));
        var radio = (0.8 + q.r * 14) * q.s * tamano;

        ctx.fillStyle = 'rgba(' + rr + ',' + gg + ',' + bb + ',' + alfa.toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(q.x, q.y, radio, 0, 6.2832);
        ctx.fill();
      }
    };

    var cuadro = function (marca) {
      if (!lienzo.isConnected) {
        corriendo = false;
        return;
      }
      if (!visible || document.hidden) {
        corriendo = false;
        return;
      }
      if (inicio === null) inicio = marca;
      dibujar(marca - inicio);
      requestAnimationFrame(cuadro);
    };

    var arrancar = function () {
      if (reducir) {
        dibujar(0);
        return;
      }
      if (corriendo) return;
      corriendo = true;
      requestAnimationFrame(cuadro);
    };

    medir();
    dibujar(0);
    lienzo.classList.add('uro-hero__lienzo--listo');

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        medir();
        if (reducir || !corriendo) dibujar(0);
      }).observe(escena);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        if (visible) arrancar();
      }).observe(escena);
    } else {
      arrancar();
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && visible) arrancar();
    });

    if (interactivo && !reducir && seccion) {
      seccion.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var caja = escena.getBoundingClientRect();
        var dx = (e.clientX - (caja.left + caja.width / 2)) / (window.innerWidth / 2);
        var dy = (e.clientY - (caja.top + caja.height / 2)) / (window.innerHeight / 2);
        objetivoX = Math.max(-1, Math.min(1, dx));
        objetivoY = Math.max(-1, Math.min(1, dy));
      });
      seccion.addEventListener('pointerleave', function () {
        objetivoX = 0;
        objetivoY = 0;
      });
    }
  };

  var escanear = function () {
    document.querySelectorAll('.uro-hero__lienzo').forEach(iniciar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', escanear);
  } else {
    escanear();
  }

  document.addEventListener('shopify:section:load', escanear);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquesita"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-um-marquesina]';

    function limitar(valor, minimo, maximo) {
      return Math.min(Math.max(valor, minimo), maximo);
    }

    function iniciar(raiz) {
      if (!raiz || raiz.dataset.umListo === '1') return;
      raiz.dataset.umListo = '1';

      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
      var conPuntero = false;
      var pendiente = false;
      var x = 0;
      var y = 0;

      function pintar() {
        pendiente = false;
        raiz.style.setProperty('--um-x', x.toFixed(3));
        raiz.style.setProperty('--um-y', y.toFixed(3));
      }

      function pedir() {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(pintar);
      }

      function alMover(evento) {
        if (reducido.matches || evento.pointerType === 'touch') return;
        var caja = raiz.getBoundingClientRect();
        conPuntero = true;
        x = limitar(((evento.clientX - caja.left) / caja.width) * 2 - 1, -1, 1);
        y = limitar(((evento.clientY - caja.top) / caja.height) * 2 - 1, -1, 1);
        pedir();
      }

      function alSalir() {
        conPuntero = false;
        x = 0;
        alDesplazar();
      }

      function alDesplazar() {
        if (!raiz.isConnected) {
          window.removeEventListener('scroll', alDesplazar);
          return;
        }
        if (conPuntero || reducido.matches) return;
        var caja = raiz.getBoundingClientRect();
        var alto = window.innerHeight || 1;
        var centro = caja.top + caja.height / 2;
        y = limitar((centro - alto / 2) / (alto / 2), -1, 1);
        x = y * 0.6;
        pedir();
      }

      raiz.addEventListener('pointermove', alMover);
      raiz.addEventListener('pointerleave', alSalir);
      window.addEventListener('scroll', alDesplazar, { passive: true });
      alDesplazar();
    }

    function iniciarTodos(contexto) {
      (contexto || document).querySelectorAll(SELECTOR).forEach(iniciar);
    }

    iniciarTodos();
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodos(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uroboros-encabezado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-ue-encabezado]';

    function iniciar(raiz) {
      if (!raiz || raiz.dataset.ueListo === '1') return;
      raiz.dataset.ueListo = '1';

      var envoltura = raiz.closest('.shopify-section') || raiz.parentElement;
      var anuncio = raiz.querySelector('[data-ue-anuncio]');
      var hamburguesa = raiz.querySelector('[data-ue-hamburguesa]');
      var contador = raiz.querySelector('[data-ue-contador]');
      var sincronizador = raiz.querySelector('[data-ue-sincronizador]');
      var anuncioFijo = raiz.dataset.anuncioFijo === 'true';

      function medir() {
        var desfase = anuncio && !anuncioFijo ? anuncio.offsetHeight : 0;
        envoltura.style.setProperty('--ue-desfase', desfase + 'px');
      }

      function cerrarSubmenus(excepto) {
        raiz.querySelectorAll('.ue-item--abierto').forEach(function (item) {
          if (item === excepto) return;
          item.classList.remove('ue-item--abierto');
          var flecha = item.querySelector('[data-ue-flecha]');
          if (flecha) flecha.setAttribute('aria-expanded', 'false');
        });
      }

      function cerrarMenu() {
        raiz.classList.remove('ue-menu-abierto');
        if (hamburguesa) hamburguesa.setAttribute('aria-expanded', 'false');
      }

      medir();
      window.addEventListener('resize', medir);
      window.addEventListener('load', medir);
      if (anuncio && 'ResizeObserver' in window) {
        new ResizeObserver(medir).observe(anuncio);
      }

      if (hamburguesa) {
        hamburguesa.addEventListener('click', function () {
          var abierto = raiz.classList.toggle('ue-menu-abierto');
          hamburguesa.setAttribute('aria-expanded', abierto ? 'true' : 'false');
          if (!abierto) cerrarSubmenus();
        });
      }

      raiz.addEventListener('click', function (evento) {
        var flecha = evento.target.closest('[data-ue-flecha]');
        if (flecha) {
          var item = flecha.closest('.ue-item');
          var abierto = item.classList.toggle('ue-item--abierto');
          flecha.setAttribute('aria-expanded', abierto ? 'true' : 'false');
          cerrarSubmenus(item);
          return;
        }
        if (evento.target.closest('.ue-enlace, .ue-subenlace')) {
          cerrarSubmenus();
          cerrarMenu();
        }
      });

      document.addEventListener('click', function (evento) {
        if (raiz.contains(evento.target)) return;
        cerrarSubmenus();
        cerrarMenu();
      });

      document.addEventListener('keydown', function (evento) {
        if (evento.key !== 'Escape') return;
        cerrarSubmenus();
        cerrarMenu();
      });

      if (contador && sincronizador && 'MutationObserver' in window) {
        new MutationObserver(function () {
          var burbuja = sincronizador.querySelector('.cart-count-bubble span[aria-hidden]');
          var cantidad = burbuja ? parseInt(burbuja.textContent, 10) : 0;
          contador.textContent = isNaN(cantidad) ? contador.textContent : cantidad;
        }).observe(sincronizador, { childList: true, subtree: true, characterData: true });
      }
    }

    function iniciarTodos(contexto) {
      (contexto || document).querySelectorAll(SELECTOR).forEach(iniciar);
    }

    iniciarTodos();
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodos(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uroboros-hero-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-uc-carrusel]';

    function limitar(valor, minimo, maximo) {
      return Math.min(Math.max(valor, minimo), maximo);
    }

    function iniciar(raiz) {
      if (!raiz || raiz.dataset.ucListo === '1') return;
      raiz.dataset.ucListo = '1';

      var pista = raiz.querySelector('[data-uc-pista]');
      var escenario = raiz.querySelector('[data-uc-escenario]');
      var pestanas = Array.prototype.slice.call(raiz.querySelectorAll('[data-uc-pestana]'));
      var diapositivas = Array.prototype.slice.call(raiz.querySelectorAll('[data-uc-diapositiva]'));
      if (!pista || !escenario || !pestanas.length || !diapositivas.length) return;

      var escritorio = window.matchMedia('(min-width: 749px)');
      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
      var autoplay = raiz.dataset.autoplay === 'true';
      var intervalo = (parseFloat(raiz.dataset.intervalo) || 6) * 1000;
      var velocidad = parseFloat(raiz.dataset.velocidad) || 0;
      var indice = 0;
      var temporizador = null;
      var enPausa = false;
      var cuadroPendiente = false;

      function ubicarTarjeta() {
        var pestana = pestanas[indice];
        var etiqueta = pestana.querySelector('[data-uc-etiqueta]') || pestana;
        var tarjeta = diapositivas[indice].querySelector('[data-uc-tarjeta]');
        var cajaPista = pista.getBoundingClientRect();
        var cajaEtiqueta = etiqueta.getBoundingClientRect();
        var inicio = cajaEtiqueta.left - cajaPista.left;
        var centro = inicio + Math.min(cajaEtiqueta.width / 2, 60);
        var anchoTarjeta = tarjeta ? tarjeta.offsetWidth : 0;
        var x = 0;
        if (escritorio.matches) {
          x = limitar(inicio, 0, Math.max(0, cajaPista.width - anchoTarjeta));
        }
        var flecha = limitar(centro - x, 24, Math.max(24, anchoTarjeta - 24));
        raiz.style.setProperty('--uc-tarjeta-x', x.toFixed(1) + 'px');
        raiz.style.setProperty('--uc-flecha-x', flecha.toFixed(1) + 'px');
      }

      function moverGigante() {
        if (!velocidad || reducido.matches) {
          raiz.style.setProperty('--uc-gigante-x', '0px');
          return;
        }
        var caja = escenario.getBoundingClientRect();
        var x = (caja.top - window.innerHeight * 0.3) * velocidad;
        raiz.style.setProperty('--uc-gigante-x', x.toFixed(1) + 'px');
      }

      function refrescar() {
        if (cuadroPendiente) return;
        cuadroPendiente = true;
        window.requestAnimationFrame(function () {
          cuadroPendiente = false;
          ubicarTarjeta();
          moverGigante();
        });
      }

      function desplazarPista() {
        var pestana = pestanas[indice];
        var maximo = Math.max(0, pista.scrollWidth - pista.clientWidth);
        var destino = limitar(pestana.offsetLeft - (pista.clientWidth - pestana.offsetWidth) / 2, 0, maximo);
        if (typeof pista.scrollTo === 'function') {
          pista.scrollTo({ left: destino, behavior: reducido.matches ? 'auto' : 'smooth' });
        } else {
          pista.scrollLeft = destino;
        }
      }

      function activar(nuevo, enfocar) {
        var total = diapositivas.length;
        indice = ((nuevo % total) + total) % total;
        pestanas.forEach(function (pestana, i) {
          var activa = i === indice;
          pestana.classList.toggle('uc-pestana--activa', activa);
          pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
          pestana.tabIndex = activa ? 0 : -1;
        });
        diapositivas.forEach(function (diapositiva, i) {
          var activa = i === indice;
          diapositiva.classList.toggle('uc-activa', activa);
          diapositiva.setAttribute('aria-hidden', activa ? 'false' : 'true');
          if (activa) {
            var tarjeta = diapositiva.querySelector('[data-uc-tarjeta]');
            if (tarjeta) tarjeta.classList.remove('uc-tarjeta--cerrada');
          }
        });
        if (enfocar) pestanas[indice].focus({ preventScroll: true });
        desplazarPista();
        refrescar();
      }

      function detener() {
        if (temporizador) window.clearInterval(temporizador);
        temporizador = null;
      }

      function programar() {
        detener();
        if (!autoplay || diapositivas.length < 2 || reducido.matches) return;
        temporizador = window.setInterval(function () {
          if (enPausa || document.hidden) return;
          activar(indice + 1, false);
        }, intervalo);
      }

      pista.addEventListener('click', function (evento) {
        var pestana = evento.target.closest('[data-uc-pestana]');
        if (!pestana) return;
        activar(pestanas.indexOf(pestana), false);
        programar();
      });

      pista.addEventListener('keydown', function (evento) {
        var destino = null;
        if (evento.key === 'ArrowRight') destino = indice + 1;
        if (evento.key === 'ArrowLeft') destino = indice - 1;
        if (evento.key === 'Home') destino = 0;
        if (evento.key === 'End') destino = pestanas.length - 1;
        if (destino === null) return;
        evento.preventDefault();
        activar(destino, true);
        programar();
      });

      pista.addEventListener('scroll', refrescar, { passive: true });

      raiz.addEventListener('click', function (evento) {
        var cerrar = evento.target.closest('[data-uc-cerrar]');
        if (!cerrar) return;
        var tarjeta = cerrar.closest('[data-uc-tarjeta]');
        if (tarjeta) tarjeta.classList.add('uc-tarjeta--cerrada');
      });

      raiz.addEventListener('mouseenter', function () {
        enPausa = true;
      });
      raiz.addEventListener('mouseleave', function () {
        enPausa = false;
      });
      raiz.addEventListener('focusin', function () {
        enPausa = true;
      });
      raiz.addEventListener('focusout', function () {
        enPausa = false;
      });

      function alDesplazar() {
        if (!raiz.isConnected) {
          window.removeEventListener('scroll', alDesplazar);
          window.removeEventListener('resize', alDesplazar);
          detener();
          return;
        }
        refrescar();
      }

      window.addEventListener('scroll', alDesplazar, { passive: true });
      window.addEventListener('resize', alDesplazar);
      window.addEventListener('load', refrescar);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refrescar);
      }

      raiz.ucCarrusel = {
        activar: function (nuevo) {
          autoplay = false;
          detener();
          activar(nuevo, false);
        }
      };

      refrescar();
      programar();
    }

    function iniciarTodos(contexto) {
      (contexto || document).querySelectorAll(SELECTOR).forEach(iniciar);
    }

    iniciarTodos();
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodos(evento.target);
    });
    document.addEventListener('shopify:block:select', function (evento) {
      var diapositiva = evento.target.closest('[data-uc-diapositiva]');
      if (!diapositiva) return;
      var raiz = diapositiva.closest(SELECTOR);
      if (!raiz || !raiz.ucCarrusel) return;
      raiz.ucCarrusel.activar(parseInt(diapositiva.getAttribute('data-uc-diapositiva'), 10) || 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uroboros-pie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-up-subir]');
      if (!boton) return;
      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducido ? 'auto' : 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
